import React, { Component } from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';
import Typography from '../../Typography';
import FormattedPercentage from '../../FormattedPercentage';
import FormattedCurrency from '../../FormattedCurrency';
import DiscountCouponIcon from '../../icons/DiscountCouponIcon';
import AccessCouponIcon from '../../icons/AccessCoupon';
import CloseIcon from '../../icons/CloseIcon';
import { mapStateToProps } from '../../redux/couponSnackbar';

class CouponSnackbar extends Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    onClick: PropTypes.func.isRequired,
    visible: PropTypes.bool.isRequired,
    coupon: PropTypes.object,
    error: PropTypes.object,
  };

  static defaultProps = {
    coupon: undefined,
    error: undefined,
  };

  state = {
    dismissed: false,
  };

  handleDismissClick = event => {
    event.stopPropagation();
    this.setState({ dismissed: true });
  };

  renderIcon() {
    const coupon = this.props.coupon || {};

    switch (coupon.type) {
      case 'access':
        return <AccessCouponIcon />;
      case 'discount':
        return <DiscountCouponIcon />;
      default:
        return null;
    }
  }

  render() {
    const { classes, onClick, error, visible } = this.props;
    const { dismissed } = this.state;
    const coupon = this.props.coupon || {};
    const showSnackbar =
      visible &&
      !dismissed &&
      (coupon.discountValue || coupon.discountPercentage || coupon.type === 'access' || error);

    if (!showSnackbar) {
      return null;
    }

    return (
      <div
        className={error ? classNames(classes.root, classes.rootErrorColor) : classes.root}
        onClick={error ? this.handleDismissClick : onClick}
      >
        <Typography className={classes.content} type="caption" component="div">
          {this.renderIcon()}
          <span className={classes.message}>
            <FormattedMessage
              id={error ? 'couponErrorSnackbarMessage' : `${coupon.type}CouponSnackbarMessage`}
              values={{
                discount: coupon.discountPercentage ? (
                  <FormattedPercentage value={coupon.discountPercentage} />
                ) : (
                  <FormattedCurrency value={coupon.discountValue} />
                ),
              }}
            />
          </span>
          <CloseIcon onClick={this.handleDismissClick} />
        </Typography>
      </div>
    );
  }
}

const stylesheet = theme => ({
  root: {
    position: 'fixed',
    left: 0,
    right: 0,
    bottom: 0,
    cursor: 'pointer',
    animation: '1s slide-up',
    zIndex: 5,
    backgroundColor: theme.palette.success[500],
  },
  rootErrorColor: {
    backgroundColor: theme.palette.grey.grey,
  },
  content: {
    margin: [[0, 'auto']],
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    maxWidth: theme.breakpoints.values.lg + 2 * theme.spacing.small,
    padding: theme.spacing.small,
    color: theme.palette.common.white,
    fontWeight: 'bold',
  },
  message: {
    flex: 1,
    margin: [[0, theme.spacing.xsmall]],
  },
  '@keyframes slide-up': {
    from: {
      transform: 'translateY(100%)',
    },
    to: {
      transform: 'translateY(0)',
    },
  },
});

export default connect(mapStateToProps)(injectSheet(stylesheet)(CouponSnackbar));



// WEBPACK FOOTER //
// ./src/site-render/src/RegisterExtension/CouponSnackbar/CouponSnackbar.js